export default "__VITE_ASSET__ZF1ZdTkU__"